import { render, staticRenderFns } from "./OveridelabelsModal.vue?vue&type=template&id=62fde22c&"
import script from "./OveridelabelsModal.vue?vue&type=script&lang=ts&"
export * from "./OveridelabelsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports